export default __webpack_public_path__ + "static/media/Like-Psy-CoverAnim.9a97e186.mp4";